import React from 'react';
import {connect} from 'react-redux';

import Repeater from '@Utils/Repeater';
import Card from '../utils/Card';

import {CardDisplay} from '../utils/CardDisplay';
import {container} from "@Container";
import {TYPES} from "@Types";
import {AppState} from "@Redux/store";
import {Dispatch} from "@Redux/type";
import {Match} from "@Models";
import {MatchAction} from "@Redux/actions";
import { FormattedMessage } from 'react-intl';
import { defaultMessages } from '@I18n/default';

const Matches: React.FC<MatchesProps> = ({draftId, myTeamId, matches, fetchData}) => {
  React.useEffect(() => {
    fetchData(draftId);
  }, []);

  return (
    <div className="matches">
      <h2 className="catcher"><FormattedMessage {...defaultMessages.toolPairingMatchesTables} /></h2>
      <div className="row">
        <Repeater data={matches} indexPrefix='draw'>
          {
            (item: Match) =>
              <div className="col-12 col-md-4 row card-armies justify-content-center mt-1 mb-1">
                <Card display={CardDisplay.MATCH}
                      selectable={false}
                      my={item.myTeamArmy.teamId === myTeamId}
                      army={item.myTeamArmy}/>
                <div className="col-1 separator p-0 text-center mt-5 mb-2">Vs</div>
                <Card display={CardDisplay.MATCH}
                      selectable={false}
                      my={item.opponentTeamArmy.teamId === myTeamId}
                      army={item.opponentTeamArmy}/>
              </div>
          }
        </Repeater>
      </div>
    </div>
  );
};

const mapStateToProps = (state: AppState) => ({
  draftId: state.draft.entity!.id,
  myTeamId: state.myTeam.entity!.id,
  matches: state.matches.entity
});

const mapDispatchToProps = (dispatch: Dispatch) => {
  const matchAction = container.get <MatchAction>(TYPES.Actions.Tool.MatchAction)
  return {
    fetchData: (draftId: string) => dispatch(matchAction.getMatches(draftId))
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(Matches);

type MatchesProps = ReturnType<typeof mapDispatchToProps> &
  ReturnType<typeof mapStateToProps>
